var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"id":"nav-tabs","align-with-title":"","light":""}},[_c('v-tab',{attrs:{"to":"/manual"}},[_vm._v(_vm._s(_vm.$t('layout.tabs.manual')))]),_c('v-tabs-slider',{attrs:{"id":"tab-slider"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }